import type { PortalNavItem } from '@ignite/ui';
import { createElement } from 'react';
import {
  Bookmark,
  ChartNoAxesCombined,
  CircleHelp,
  CreditCard,
  Database,
  HeartPulse,
  LayoutDashboard,
  NotebookPen,
  Settings,
  Sparkles,
  Unplug,
} from 'lucide-react';

export type WorkbenchView =
  | 'overview'
  | 'plugin'
  | 'accountData'
  | 'skills'
  | 'diagnosis'
  | 'billing'
  | 'competitor'
  | 'savedTopics'
  | 'creator'
  | 'help'
  | 'settings';

const exactWorkbenchViews: Readonly<Record<string, WorkbenchView>> = {
  '/': 'overview',
  '/plugin': 'plugin',
  '/account-data': 'accountData',
  '/skills': 'skills',
  '/diagnosis': 'diagnosis',
  '/billing': 'billing',
  '/competitor': 'competitor',
  '/saved-topics': 'savedTopics',
  '/help': 'help',
  '/settings': 'settings',
};

export function resolveWorkbenchView(pathname: string): WorkbenchView | null {
  if (pathname === '/creator' || pathname.startsWith('/creator/')) return 'creator';
  return exactWorkbenchViews[pathname] ?? null;
}

export function buildNavItems(t: (key: string) => string, active: WorkbenchView): PortalNavItem[] {
  return [
    {
      label: t('portal.nav.dashboard'),
      href: '/',
      icon: createElement(LayoutDashboard),
      active: active === 'overview',
    },
    {
      label: t('portal.nav.creator'),
      href: '/creator',
      icon: createElement(NotebookPen),
      active: active === 'creator',
    },
    {
      label: t('portal.nav.savedTopics'),
      href: '/saved-topics',
      icon: createElement(Bookmark),
      active: active === 'savedTopics',
    },
    {
      label: t('portal.nav.competitor'),
      href: '/competitor',
      icon: createElement(ChartNoAxesCombined),
      active: active === 'competitor',
    },
    {
      label: t('portal.nav.diagnosis'),
      href: '/diagnosis',
      icon: createElement(HeartPulse),
      active: active === 'diagnosis',
    },
    {
      label: t('portal.nav.accountData'),
      href: '/account-data',
      icon: createElement(Database),
      active: active === 'accountData',
    },
    {
      label: t('portal.nav.skills'),
      href: '/skills',
      icon: createElement(Sparkles),
      active: active === 'skills',
    },
    {
      label: t('portal.nav.plugin'),
      href: '/plugin',
      icon: createElement(Unplug),
      active: active === 'plugin',
    },
  ];
}

export function buildUserMenuItems(
  t: (key: string) => string,
  active: WorkbenchView,
): PortalNavItem[] {
  return [
    {
      label: t('portal.nav.settings'),
      href: '/settings',
      icon: createElement(Settings),
      active: active === 'settings',
    },
    {
      label: t('portal.nav.billing'),
      href: '/billing',
      icon: createElement(CreditCard),
      active: active === 'billing',
    },
    {
      label: t('portal.nav.help'),
      href: '/help',
      icon: createElement(CircleHelp),
      active: active === 'help',
    },
  ];
}
